module.exports = __webpack_public_path__ + "img/arrow_back_primary.12f3d3f4.svg";